module.exports = __webpack_public_path__ + "assets/img/img99.3f1ee27e.png";